/* eslint-disable no-unused-vars */
export enum Background {
  CLIPPED = 'clipped',
  CLIPPED_RESPONSIVE = 'clipped-responsive',
  NONE = '',
}
